import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';
import FormGenerality from './form';
interface AccordionGeneralityProps {
  isEdit?: boolean;
}

const AccordionGeneralityComponent = ({ isEdit }: AccordionGeneralityProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldGeneralityChange = useEventCallback(
    (
      key: keyof AccordionGeneralityForm,
      value: AccordionGeneralityForm[keyof AccordionGeneralityForm]
    ) => {
      formContext.setFieldValue('generality', {
        ...(formContext.values.generality || {}),
        [key]: value,
      });
    }
  );

  const onFieldsGeneralityChange = useEventCallback((values: AccordionGeneralityForm) => {
    formContext.setFieldValue('generality', {
      ...(formContext.values.generality || {}),
      ...values,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-generality-content"
          id="panel-generality-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>
            Generalità
            {formContext?.errors?.generality && formContext?.touched?.generality ? (
              <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
                Attenzione verificare dati errati o mancanti
              </Typography>
            ) : undefined}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGenerality
            onChangeGenerality={onFieldGeneralityChange}
            onChangeFieldsGenerality={onFieldsGeneralityChange}
            generality={formContext.values.generality || undefined}
            errorsGenerality={
              formContext.errors.generality as FormikErrors<AccordionGeneralityForm>
            }
            touchedGenerality={
              formContext.touched.generality as FormikTouched<AccordionGeneralityForm>
            }
            labelMunicipalityItalian="Comune nascita"
            labelProvinceItalian="Provincia nascita"
            disabledValidityFiscalCode
            disabled={isEdit}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionGeneralityComponent.displayName = 'Accordion generality component';

const AccordionGenerality = memo(AccordionGeneralityComponent);

export default AccordionGenerality;
